import React from 'react';
import { Icon } from './Icons.jsx';
import { formatClock } from '../lib/format.js';

const SPEEDS = [0.25, 0.5, 1, 2];

export function TransportBar({
  running,
  finished,
  speed,
  time,
  onToggle,
  onReset,
  onStep,
  onSpeedChange,
  vectors,
  grid,
  trail,
  onToggleVectors,
  onToggleGrid,
  onToggleTrail,
  onFullscreen,
  fullscreen,
}) {
  return (
    <div className="transport">
      <div className="transport-left">
        <button
          type="button"
          className={`play-button ${running ? 'is-running' : ''}`}
          onClick={onToggle}
          aria-label={running ? '暂停' : finished ? '重新播放' : '播放'}
          title="空格：播放 / 暂停"
        >
          <Icon name={running ? 'pause' : finished ? 'refresh' : 'play'} size={20} strokeWidth={2} />
        </button>
        <button type="button" className="transport-btn" onClick={onReset} title="重置实验（R）">
          <Icon name="reset" size={18} />
          <span>重置</span>
        </button>
        <button type="button" className="transport-btn" onClick={onStep} title="单步推进 1/30 秒" disabled={running}>
          <Icon name="step" size={17} />
          <span>单步</span>
        </button>
      </div>

      <div className="transport-center">
        <div className="time-readout">
          <span className="time-label">SIM TIME</span>
          <strong>{formatClock(time)}</strong>
        </div>
        <div className="speed-switch" role="group" aria-label="播放倍速">
          {SPEEDS.map((item) => (
            <button
              key={item}
              type="button"
              className={speed === item ? 'active' : ''}
              onClick={() => onSpeedChange(item)}
            >
              {item}×
            </button>
          ))}
        </div>
      </div>

      <div className="transport-right">
        <button
          type="button"
          className={`toggle-btn ${vectors ? 'active' : ''}`}
          onClick={onToggleVectors}
          title="显示/隐藏力与速度矢量"
        >
          <Icon name="activity" size={17} />
          <span>矢量</span>
        </button>
        <button
          type="button"
          className={`toggle-btn ${grid ? 'active' : ''}`}
          onClick={onToggleGrid}
          title="显示/隐藏网格"
        >
          <Icon name="grid" size={16} />
          <span>网格</span>
        </button>
        <button
          type="button"
          className={`toggle-btn ${trail ? 'active' : ''}`}
          onClick={onToggleTrail}
          title="显示/隐藏运动轨迹"
        >
          <Icon name="eye" size={17} />
          <span>轨迹</span>
        </button>
        <button type="button" className="icon-btn" onClick={onFullscreen} title="全屏演示">
          <Icon name={fullscreen ? 'minimize' : 'maximize'} size={17} />
        </button>
      </div>
    </div>
  );
}
